<template>
  <Breadcrumbs
    title="Daily Sales Monitoring Report"
    :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <DailySalesMonitoringForm />
    </div>
  </div>
</template>

<script>
import DailySalesMonitoringForm from './dailysalesmonitoring_form.vue';

export default {
  name: "DailySalesMonitoringPage",
  components: {
    DailySalesMonitoringForm,
  },
};
</script>

